
import React, { createContext, useContext } from 'react';

type Theme = 'light';

interface ThemeContextType {
  theme: Theme;
  setTheme: (theme: Theme) => void;
  actualTheme: 'light';
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  // Always use light theme - simplified for Flamingo's clean design
  const theme: Theme = 'light';
  const actualTheme = 'light' as const;

  // Ensure dark class is never applied
  if (typeof document !== 'undefined') {
    document.documentElement.classList.remove('dark');
  }

  const setTheme = () => {
    // No-op - always light mode for consistent branding
  };

  return (
    <ThemeContext.Provider value={{ theme, setTheme, actualTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}
